/**
 * @param {string} message
 * @param {'success' | 'error' | 'notice'} type
 * @param {number} [timeout]
 */
export default function raiseNotification(message, type, timeout) {
    let notificationList = document.querySelector("#notification");
    let notificationListItem = document.createElement("li");

    type = type || "";
    timeout = timeout || 5000;

    notificationListItem.innerText = message;
    notificationListItem.classList.add(type);
    notificationList.append(notificationListItem);
    notificationList.style.display = "block";

    setTimeout(() => {
        notificationList.removeChild(notificationListItem);
    }, timeout);
}
